import {ArianeElement, ArianeStore, ModalService} from "@digicerba/common";
import {GestionArticleDto, IGestionCatalogueWebServiceClient} from "@resources/resources";
import {ActivatedRoute} from "@angular/router";
import {AsiTable, AsiTableData} from "@asi-ngtools/lib";
import {Component, ViewChild} from "@angular/core";
import * as lodash from "lodash";

@Component({
  selector: 'admin-article-component',
  templateUrl: './admin.articles.component.html',
  host: {'class': 'page'}
})
export class AdminArticleComponent {

  @ViewChild('cmArticleDataTable') articleTable: AsiTable<GestionArticleDto>;
  asiTableData: AsiTableData<GestionArticleDto> = new AsiTableData<GestionArticleDto>();

  constructor(private arianeStore: ArianeStore, private activatedRoute: ActivatedRoute, private modalService: ModalService,
              private gestionCatalogueWebServiceClient: IGestionCatalogueWebServiceClient) {
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "ARIANNE.module",
        route: "/"
      },
      {
        libelle: "ARIANNE.ADMINISTRATION.administration",
        route: "/administration"
      },
      {
        libelle: "ARIANNE.ADMINISTRATION.articles",
        route: "/administration/articles"
      }
    ];

    arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {
    this.asiTableData.results = this.activatedRoute.snapshot.data['articles'];
  }

  ngAfterContentInit() {
    this.articleTable.updateData(this.asiTableData);
  }

  openModal(id: number) {
    this.modalService.openConfirmDialog("MODAL.ADMIN.SUPPRESSION_ARTICLE.title", "MODAL.ADMIN.SUPPRESSION_ARTICLE.message",
      "MODAL.ADMIN.SUPPRESSION_ARTICLE.confirm", "MODAL.ADMIN.SUPPRESSION_ARTICLE.cancel").onDialogClose().subscribe(() => {
      this.gestionCatalogueWebServiceClient.deleteArticle(id).subscribe(response => {
        lodash.remove(this.asiTableData.results, function (o) {
          return o.id == id;
        });
        this.articleTable.updateData(this.asiTableData);
      });
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/administration/articles/admin.articles.component.ts